import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import { Button, Form, Grid } from 'semantic-ui-react'
import {client} from '../../Client';
import 'react-date-picker/index.css'
import PropTypes from 'prop-types';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'


class PreviewNewsForm extends Component {
    constructor(props) {
        super(props);
        let fields = null;
        this.state = {
            news: props.item,
            fields: fields,
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
        };
        this.onOkClick = this.onOkClick.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.loadData = this.loadData.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.item.idNews !== this.state.news.idNews)
        {
            this.setState({
                news: nextProps.item
            })
            this.loadData();
        }
    }
    componentDidMount(){
        // Carica l'oggetto completo
        if(this.state.news){
            this.loadData();
        }
    }

    loadData() {
        this.setState({_loading: true});
        client.loadNews(this.state.news.idNews).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    
                    this.setState({
                        fields: data,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.onOkClick(this.state.news);
    }

    onOkClick(news) {
        if (this.props.onOkClick)
        {
            this.props.onOkClick(news);
        }
    }

    render() {
        let c = this.state.news;
        if (this.state.fields){
            c = this.state.fields;
        }

        let btnModifica = null;
        if (client.getCurrentUser().isrolenewsw){
            btnModifica = (<Button primary type='' onClick={(ev) => (this.props.onUpdateClick(c))}><i className="edit icon"/>
                        Modifica
                    </Button>);
        }

        let buttons = null;
        if (this.props.showButtons){
            buttons = (<Grid.Row style={{height:'40px'}}>
                <Grid.Column textAlign="center">
                    <Button className="button red" type='' onClick={(ev) => (this.props.onOkAClick(c))}><i className="eye icon"/>
                        Scarta
                    </Button>
                    <Button className="button green" type='' onClick={(ev) => (this.props.onOkBClick(c))}><i className="check icon"/>
                        Imposta come letta
                    </Button>
                    <Button secondary type='submit' ><i className="undo icon"/>Chiudi</Button>
                    {btnModifica}
                </Grid.Column>
            </Grid.Row>);
        }

        let inCommessaLink = null;
        if(c.idCommessa){
            if (client.getCurrentUser().isrolecommessew) {
                inCommessaLink = (<label className="ui gray rounded label"><Link to={`/app/commesse/view/${c.idCommessa.idCommessa}`}>{c.idCommessa.nomeCompleto}</Link></label>);
            }else{
                inCommessaLink= (<label className="ui gray label">{c.idCommessa.nomeCompleto}</label>)
            }
        }
        let inGaraLink = null;
        if(c.idGara){
            if (client.getCurrentUser().isrolegarew) {
                inGaraLink = (<label className="ui gray rounded label"><Link to={`/app/gare/view/${c.idGara.idGara}`}>{c.idGara.nomeCompleto}</Link></label>);
            }else{
                inGaraLink= (<label className="ui gray label">{c.idGara.nomeCompleto}</label>)
            }
        }

        return (
            <Form  onSubmit={this.handleSubmit} success={this.state.saveSuccess}>
                <Grid >
                    
                    <Grid.Row >
                        <Grid.Column textAlign="left">


                            <Form.TextArea  name='testo'  placeholder='' rows="24" value={c.testo} readOnly='true'/>
                            
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row >
                        <Grid.Column textAlign="center">
                                {inCommessaLink} {inGaraLink}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row >
                    <Grid.Column textAlign="left">
                            Creata il {c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>} da <b>{c.creatoDa ? c.creatoDa.username : '?'}</b>&nbsp;
                            Modificata il {c.modificatoIl ?  <b><LocalDate data={c.modificatoIl } /> <LocalTime data={c.modificatoIl } /></b> : <b>?</b>} da <b>{c.modificatoDa ? c.modificatoDa.username : '?'}</b>
                        </Grid.Column>
                    </Grid.Row>
                    {buttons}
                </Grid>
            </Form>)


    }
}

PreviewNewsForm.PropTypes = {
    item: PropTypes.object, // La news
    showButtons: PropTypes.boolean,
    onOkClick: PropTypes.func.isRequired,
    onOkAClick: PropTypes.func.isRequired, // Case A button (see RIC01062025-01 v4.2.0)
    onOkBClick: PropTypes.func.isRequired, // Case B Button
    onUpdateClick: PropTypes.func.isRequired, 
}

PreviewNewsForm.defaultProps = {
    showButtons: true
};
export default PreviewNewsForm;




/** WEBPACK FOOTER **
 ** ./src/components/news/PreviewNewsForm.jsx
 **/